import type { Role } from '@repo/api-gw-sdk';

const rolesOrder: Record<string, number> = {
  '543bad56-e9b2-421f-8456-b43c53fcebfe': 0, // Global viewer
  '379a1104-838a-4bf3-af96-da3af27c5712': 1, // Global admin
  'd6afa067-d3a0-457e-923d-27cd26c9e5cb': 2, // Cloud viewer
  '21d0ae2b-9bbc-4a41-bd5e-98011e9f10a5': 3, // Cloud operator
  'a675e456-8602-4550-9c65-66583404e0d6': 4, // Cloud admin
  '7b35aa30-8f59-4c0c-99d6-512a0d88d2a1': 5, // SaaS viewer
  '10ae1b5b-5e58-491a-a6a4-e50372bc2378': 6, // SaaS operator
  '5ed448ab-c1e2-4e97-ac67-cb0278f514ff': 7, // SaaS admin
  'dcd9e71e-de9d-41f0-abd1-df9943a7e393': 8, // BI user
};

export const rolesComparer = (a: Role, b: Role) => {
  if (a.isBuiltInRole || b.isBuiltInRole) {
    if (a.isBuiltInRole && b.isBuiltInRole) {
      return rolesOrder[a.id] - rolesOrder[b.id];
    } else if (a.isBuiltInRole) {
      return -1;
    } else {
      return 1;
    }
  }

  return a.name.localeCompare(b.name);
};
